import { Menu, Pagination, Row } from "antd";
import React from "react";
import "./index.scss";
const { SubMenu } = Menu;
const MenuLeft = ({
    setPaginateCurrent,
    setPerPage,
    totalItem = 0,
    currentPage = 1,
}) => {
    const [showPassword, setShowPassword] = React.useState(true);
    const onChange = (page, perPage) => {
        setPaginateCurrent(page);
        setPerPage(perPage);
    };
    const onShowSizeChange = (pageSize) => {
        console.log(pageSize);
        // setPaginateCurrent(page)
    };
    return (
        <Row align="center" justify="center">
            {totalItem > 0 ? (
                <Pagination
                    total={totalItem}
                    current={currentPage}
                    showSizeChanger
                    showQuickJumper
                    showTotal={(total) => `Total ${total} items`}
                    onChange={onChange}
                    onShowSizeChange={onShowSizeChange}
                />
            ) : (
                <></>
            )}
        </Row>
    );
};
export default MenuLeft;
